(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/draw-widgets/assets/javascripts/widget-public-container.js') >= 0) return;  svs.modules.push('/components/pool-betting/draw-widgets/assets/javascripts/widget-public-container.js');
"use strict";

const WidgetArea = svs.components.lbUtils.widgetArea.WidgetArea;
const _svs$components$sport = svs.components.sport.tipsenShared,
  drawStateEnums = _svs$components$sport.drawStateEnums,
  getDrawStateEnum = _svs$components$sport.getDrawStateEnum;
const useDraw = svs.components.sport.drawsRedux.hooks.useDraw;
const WidgetPublicContainer = _ref => {
  let drawNumber = _ref.drawNumber,
    productId = _ref.productId,
    className = _ref.className;
  const draw = useDraw({
    productId,
    drawNumber
  });
  const drawState = getDrawStateEnum(draw === null || draw === void 0 ? void 0 : draw.drawStateId);
  const isLive = drawState === drawStateEnums.LIVE;
  const classNames = ['draw-widget-container'];
  className && classNames.push(className);
  if (isLive) {
    return React.createElement(WidgetArea, {
      className: classNames.join(' '),
      widgetArea: "drawLive"
    });
  }
  return React.createElement(WidgetArea, {
    className: classNames.join(' '),
    widgetArea: "drawNotLive"
  });
};
setGlobal('svs.components.poolBetting.drawWidgets.WidgetPublicContainer', WidgetPublicContainer);

 })(window);